import { Component, OnInit, Input, OnDestroy} from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import {OrdersourceService} from './ordersource.service';
import { SetupService } from '../setup.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppMainComponent } from '../../../../app.main.component';
import { ObjectNames, Status, Severity, Answer} from '../../constants/constants';
import { TitleCasePipe } from '@angular/common';


@Component({
  selector: 'app-ordersource',
  templateUrl: './ordersource.component.html',
  styleUrls: ['./ordersource.component.scss']
})
export class OrdersourceComponent implements OnInit, OnDestroy {

  orderSourceForm: FormGroup;
  @Input() groups: any[]=[];
  allOrderSource:any[]=[];
  addEditOrderSourceHeader:string;
  displayOrderSourceAdd: boolean=false;
  sourceTypes:any[]=[];
  isAddOrderSource: boolean=false;
  invalidData:boolean=false;
  statusConstants= Status;
  answertypeConstants= Answer;

  constructor(private ordersourceService: OrdersourceService,private messageService: MessageService,
    private confirmationService: ConfirmationService, private fb: FormBuilder, private app: AppMainComponent,
    private setupService: SetupService,private titlecasePipe: TitleCasePipe) { }

  ngOnInit(): void {
    this.setupService.getOrderSource().subscribe(source => {
      if (source) {
        this.showAddOrderSource();
      }
    })
   this.getOrderSourceGroup();
    this.orderSourceForm = this.fb.group({
      id: [0],
      createdSource: [''],
      updatedSource: [''],
      createdBy: [''],
      updatedBy: [''],
      createdDate: [''],
      updatedDate: [''],
      organizationId: [''],
      name: ['',[Validators.required,Validators.pattern(/^(?!\s*$).+/)]],
      description: [''],
      statusId: [true],
      typeId: ['']
    });
    this.loadOrderSource();
  }

  getOrderSourceGroup() {
    // this.ordersourceService.getAllGroups().subscribe((groups) => {
    //   const orderSourceGroup = groups.filter(group => group.name == 'OrderSourceType')[0];
    //   this.getAllSourceTypes(orderSourceGroup.id);
    // })

      const orderSourceGroup = this.groups.filter(group => group.name == ObjectNames.setupConstants.OrderSource_Name)[0];
      this.getAllSourceTypes(orderSourceGroup.id);

  }

  getAllSourceTypes(id) {
    this.ordersourceService.getAllSourceTypes(id).subscribe((types) => {
      this.sourceTypes = types;
      this.orderSourceForm.controls['typeId'].setValue(this.sourceTypes[0]);
    })
  }

  loadOrderSource() {
    this.ordersourceService.getOrderSourceList().subscribe((source) => {
      if(source){
        this.allOrderSource = source;
      }
    })
  }

  deleteOrderSource(source){
    this.confirmationService.confirm({
      message: 'Do you want to delete this Order Source?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.ordersourceService.deleteOrderSource(source.id).then(() => {
          this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Deleted Successfully...' });
          const index = this.allOrderSource.indexOf(source);
          this.allOrderSource.splice(index, 1);
        }).catch(() => {
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while deleting data...' });
        });
      },
      reject: () => {
      }
    });
  }

  showAddOrderSource(){
    this.addEditOrderSourceHeader = ObjectNames.setupConstants.AddOrderSourceTitle;
    this.displayOrderSourceAdd = true;
    this.isAddOrderSource=true;
    this.invalidData=false;
    this.orderSourceForm = this.fb.group({
      id: [0],
      createdSource: [this.app.userIP],
      updatedSource: [this.app.userIP],
      createdBy: [this.app.userId],
      updatedBy: [this.app.userId],
      createdDate: [new Date().toISOString()],
      updatedDate: [new Date().toISOString()],
      organizationId: [this.app.companyId],
      name: ['',[Validators.required,Validators.pattern(/^(?!\s*$).+/)]],
      description: [''],
      statusId: [true],
      typeId: [this.sourceTypes[0]]
    });

  }

  showEditOrderSource(source){
    this.addEditOrderSourceHeader = ObjectNames.setupConstants.EditOrderSourceTitle;
    this.displayOrderSourceAdd = true;
    this.isAddOrderSource=false;
    this.invalidData=false;
    this.orderSourceForm.patchValue(source);
    this.orderSourceForm.controls['statusId'].setValue(source.statusId==Status.ACTIVE?true:false);
    const filteredType= this.sourceTypes.filter(type=> type.id==source.typeId)[0];
    this.orderSourceForm.controls['typeId'].setValue(filteredType);
  }

  saveOrderSource(value){
    this.invalidData=false;
    //1-Active AND 2-InActive
    value.statusId = value.statusId == true ? Status.ACTIVE : Status.INACTIVE;
    value.typeId = value.typeId.id;
    const lowerCaseNames = [];

    if (this.isAddOrderSource) {
      for (let s of this.allOrderSource) {
        lowerCaseNames.push(s.name.toLowerCase().replace(/ /g, ''))
      }
      if (lowerCaseNames.indexOf(value.name.toLowerCase().replace(/ /g, '')) > -1) {
        this.invalidData = true;
      }else{
        this.ordersourceService.addOrderSource(value).then(() => {
          this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Order Source Added successfully...' });
          this.loadOrderSource();
          this.displayOrderSourceAdd = false;
        }).catch(() => {
          this.displayOrderSourceAdd = false;
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
        });
      }
    } else {
      const duplicateRecord = this.allOrderSource.find(depOb => depOb.name.toLowerCase().replace(/ /g, '') == value.name.toLowerCase().replace(/ /g, '') && depOb.id !== value.id)
      if (duplicateRecord) {
        this.invalidData = true;
      } else {
        this.invalidData = false;
        value.updatedBy = this.app.userId;
        value.updatedDate = new Date().toISOString();
        value.updatedSource = this.app.userIP;
        this.ordersourceService.updateOrderSource(value).then(() => {
          this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Order Source Updated successfully...' });
          this.loadOrderSource();
          this.displayOrderSourceAdd = false;
        }).catch(() => {
          this.displayOrderSourceAdd = false;
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
        });
      }
    }
  }

  ngOnDestroy(): void 
  {
    this.setupService.setOrderSource('');
  }

}
